import * as Sentry from '@sentry/nextjs';
import { useState } from 'react';
import useSWR from 'swr';

const fetcher = async (url) => {
  const res = await fetch(url);
  if (!res.ok) {
    const error = new Error('An error occurred while fetching the data.');
    // Attach extra info to the error object.
    error.info = await res.json();
    error.status = res.status;
    Sentry.captureException(error);
    throw error;
  }
  return res.json();
};

const useLoadMoreLetters = (initialLetters, initialNextToken, stateCode) => {
  const url = stateCode
    ? `/api/letters/more?next=${initialNextToken}&state=${stateCode}`
    : `/api/letters/more?next=${initialNextToken}`;
  const { data, error, mutate } = useSWR(url, fetcher, {
    fallbackData: { letters: initialLetters, nextToken: initialNextToken },
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateOnMount: false,
  });

  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const letters = data?.letters || [];
  const nextToken = data?.nextToken;
  const loadingError = error?.message;

  const loadMoreLetters = async () => {
    setIsLoadingMore(true);
    const newData = await fetcher(`/api/letters/more?next=${nextToken}`);
    mutate(
      {
        letters: [...letters, ...newData.letters],
        nextToken: newData.nextToken,
      },
      false
    );
    setIsLoadingMore(false);
  };

  return { letters, isLoadingMore, loadMoreLetters, loadingError, nextToken };
};

export default useLoadMoreLetters;
